import type { ICommand } from '@model-framework/command';
import { LinkEntityOperation } from '../adapter/LinkEntityOperation';
import type { LinkEntity } from '../domain';
import type { ViewModelEntity } from '@view-model/domain/view-model';

export class LinkCreateCommand implements ICommand {
  private readonly link: LinkEntity;

  constructor(
    private readonly viewModel: ViewModelEntity,
    private readonly entityOperation: LinkEntityOperation,
    link: LinkEntity
  ) {
    this.link = link.clone();
  }

  do(): void {
    this.entityOperation.save(this.link);
  }

  undo(): void {
    const link = LinkEntityOperation.getLink(this.link.key, this.viewModel);
    if (!link) return;

    this.entityOperation.remove(link);
  }

  redo(): void {
    const link = LinkEntityOperation.getLink(this.link.key, this.viewModel);
    if (link) return;

    this.do();
  }

  async canUndo(): Promise<boolean> {
    return !!LinkEntityOperation.getLink(this.link.key, this.viewModel);
  }

  async canRedo(): Promise<boolean> {
    return !LinkEntityOperation.getLink(this.link.key, this.viewModel);
  }
}
